module.exports = __webpack_public_path__ + "img/ShlomoBluth.d1e65cd0.png";